import { render } from "./DashboardArea.vue?vue&type=template&id=7b17408c"
import script from "./DashboardArea.vue?vue&type=script&lang=js"
export * from "./DashboardArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__